import React from 'react';
import { appConfig } from '../../appConfig';

const SubHeader = () => {
  const { SubHeader } = appConfig;

  return (
    <div className="row1 pt-1 mt-1 mb-0 border-top position-relative">
      <div className="heading pt-0 pb-2">{SubHeader.title}</div>
      <div className="sub-heading pt-0 pb-2 mx-auto">
        {SubHeader.description}
      </div>
    </div>
  );
};

export default SubHeader;
